var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_951_18542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.3047L19 10.3047C19.55 10.3047 20 10.4501 20 11.0001C20 11.5501 19.55 11.6585 19 11.6585L8 11.6585C7.45 11.6585 7 11.5501 7 11.0001C7 10.4501 7.45 10.3047 8 10.3047ZM8 15.3204L21.9269 15.3204C22.4769 15.3204 22.923 15.411 22.923 15.961C22.923 16.511 22.4769 16.6474 21.9269 16.6474L8 16.6474C7.45 16.6474 7 16.511 7 15.961C7 15.411 7.45 15.3204 8 15.3204ZM7 20.9932C7 20.4432 7.45 20.3086 8 20.3086L19 20.3086C19.55 20.3086 20 20.4393 20 20.9893C20 21.5393 19.55 21.6572 19 21.6572L8 21.6572C7.45 21.6572 7 21.5432 7 20.9932Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_951_18542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 4 28)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMenu);
export default __webpack_public_path__ + "static/media/expand-menu.1ff7194671c18cab64f48765826db4d7.svg";
export { ForwardRef as ReactComponent };